import React, {useState} from 'react';
import {
  pdf,
  Page,
  Image,
  Link,
  Font,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  PDFViewer,
  BlobProvider,
} from '@react-pdf/renderer';

import {
    Table,
    TableHeader,
    TableCell,
    TableBody,
    DataTableCell,
} from '@david.kucsai/react-pdf-table';

import {
    format,
    endOfDay,
    startOfMonth,
    endOfMonth,
    isSameDay,
    subDays,
    startOfYear,
    endOfYear,
    startOfQuarter,
    endOfQuarter,
} from 'date-fns';

import OverviewData from './OverviewData';
import ReportObject, { objectFields } from './ReportObject';
import { PdfGroupedOverviewStatDetail } from './OverviewStatDetail';
import { apiUrl } from 'api';
import { Button } from '@mui/joy';
import { MaestroLogoForPdf } from './MaestroLogoForPdf';

const MaestroPdf = ({reportInfo, aggregateMasterOverview, aggregates, result}) => {
  // just in case the logo hasn't quite loaded yet
  if(reportInfo.logo === null) {
    return (
      <Document>
        <Page size="A4">
          <View />
        </Page>
      </Document>
    );
  }

  let mappedAggregates = {};
  for (const entry of aggregates) {
    mappedAggregates[entry.value] = entry.label;
  }

  const mappedCommunities = {};
  result.options.communities.map(community => mappedCommunities[community.value] = community.label);

  // console.log(mappedAggregates);

  // console.log(aggregates);
  // console.log(result.options.communities > 1);
  const firstResult = Object.entries(result)[0][1];
  // console.log(firstResult);

  let overviewTableData = [];
  for(const aggregate of aggregates) {
    if(!aggregateMasterOverview.hasOwnProperty(aggregate.value)) {
      continue;
    }

    overviewTableData.push({
      label: aggregate.label,
      // value: <View><OverviewData type={aggregate.value} data={aggregateMasterOverview[aggregate.value]} pdf={true} /></View>,
      value: <OverviewData type={aggregate.value} data={aggregateMasterOverview[aggregate.value]} pdf={true} />,
    });
  }

  const hasDetails = Object.keys(aggregateMasterOverview).filter((key) => ['businesses_relocated', 'businesses_by_type', 'properties_by_type', 'parking', 'roi', 'rent_per_square_foot'].indexOf(key) === -1).length > 0;

  let logoDimens = {
    width: Math.min(reportInfo.logo.width, 200),
    height: Math.min(reportInfo.logo.width, 200) / reportInfo.logo.aspectRatio,
  };

  return(
  <Document title={reportInfo.name} pageMode='useOutlines'>
      {/* size="A4" A4 width = 595.28 */}
      <Page size="A4" /*size={{width: '595.28', height: 'auto'}}*/ style={styles.body} /*bookmark={'Overview'}*/>
          <View style={styles.imageContainer} bookmark={'Overview'}>
            {reportInfo?.logo?.src && (<>
              <Image style={[styles.image, logoDimens]} src={reportInfo.logo.src} />
            </>)}
            {!reportInfo?.logo?.src && (<>
              <MaestroLogoForPdf/>
            </>)}
          </View>
          <View style={styles.header}>
              <View style={styles.imageContainer}>
                <Text>{reportInfo.communityName}</Text>
                {/* <Image style={styles.image} src={'https://www.maestrocm.com/wp-content/themes/mm-2019/assets/images/logo.svg'} /> */}
                </View>
              <View style={styles.maestroImageContainer}>
                {/* <Image debug style={styles.image} src="https://www.maestrocm.com/wp-content/uploads/2022/04/MM-Logo-2020-RGB.png" /> */}
                {/* <Image debug style={styles.image} src="https://i.imgur.com/PrlhrqZ.png" /> */}
              </View>
          </View>

          <Text style={styles.title}>{reportInfo.name}</Text>
          <Text style={styles.author}>Prepared by {reportInfo.author}</Text>

        {/* TODO: include reporting widgets? */}
          <View style={styles.bodyFix}>
          {reportInfo.description.length > 0 && (<>
            <Text style={styles.subtitle}>
                  Preface
            </Text>
            <Text style={styles.text}>
                  {reportInfo.description}
            </Text>
          </>)}

          <Text style={styles.subtitle} bookmark={'Reinvestment Statistics'}>
            Reinvestment Statistics Overview
          </Text>
          </View>

          <View style={styles.horizontalGrid}>
            <View style={styles.half}>
              {/* todo: make this work for all communities, like maybe set up a result.aggregates */}
              {aggregateMasterOverview && Object.keys(aggregateMasterOverview).length > 0 && (
                <View>
                  <Table
                  data={overviewTableData}
              >
                  <TableBody
                    includeTopBorder={false}
                    includeRightBorder={false}
                    includeBottomBorder={false}
                    includeLeftBorder={false}
                    evenRowColor="white"
                    oddRowColor="#E1E1E1"
                  >
                  {/* <OverviewData type={aggregate.value} data={aggregateMasterOverview[aggregate.value]} pdf /> */}
                      <DataTableCell weighting={.75} style={styles.tableCell} getContent={(r) => <Text style={styles.tableCellHeader}>{r.label}</Text>}/>
                      <DataTableCell style={styles.tableCell} getContent={(r) => r.value}/>
                  </TableBody>
              </Table>
              </View>
            )}
            </View>
            <View style={styles.half}></View>
          </View>

          {reportInfo.statsOnly === false && hasDetails === true && <>
            {/*
            <Text style={styles.subtitle}>
                  Reinvestment Statistic Details
            </Text>
            */}
            {/*
            // This will display by aggregate
            {result.options.communities.length > 1 && Object.keys(aggregateMasterOverview).length > 0 && (<>
            {Object.keys(aggregateMasterOverview).map((key, index) => {
              if(['businesses_by_type', 'properties_by_type', 'parking', 'roi', 'rent_per_square_foot'].indexOf(key) !== -1) {
                return null;
              }
              const aggregate = aggregateMasterOverview[key];
              return (<View key={index} break={true} style={{width: '100%'}}>
                <Text style={styles.tableTitle}>{mappedAggregates[key]}</Text>
                <GroupedOverviewStatDetail
                  aggregate={{label: mappedAggregates[key], value: key}}
                  // item={aggregateMasterOverview[objectField[0]]}
                  result={result}
                  communities={mappedCommunities}
                  pdf={true}
                  pdfStyles={styles}
                />
              </View>);
            })}
            </>)}
            */}
            {result.options.communities.length > 1 && Object.keys(aggregateMasterOverview).length > 0 && (<>
            {result.options.communities.map((community, index) => {
              return (
                <View key={index} break={index % 2 == 0} style={{width: '100%'}}>
                  <Text style={styles.tableTitle}>{community.label}</Text>
                  <PdfGroupedOverviewStatDetail
                  test={1}
                    aggregates={aggregates}
                    result={result[community.value]}
                    pdf={true}
                    pdfStyles={styles}
                  />
                </View>
              );
            })}
            </>)}
            {result.options.communities.length === 1 && (<>
            {Object.entries(objectFields).map((objectField, objectFieldIndex) => {
              if(!aggregateMasterOverview.hasOwnProperty(objectField[0])) {
                return null;
              }

              let sectionTitle = mappedAggregates[objectField[0]];
              if(objectField[0] == 'businesses_relocated_in') {
                sectionTitle = 'Businesses Relocated In';
              } else if(objectField[0] == 'businesses_relocated_out') {
                sectionTitle = 'Businesses Relocated Out';
              }

              return (<View key={objectFieldIndex} break={true} style={{width: '100%'}}>
                <Text style={styles.tableTitle} bookmark={sectionTitle}>{sectionTitle}</Text>

                {/*
                */}
                <ReportObject
                  aggregate={{label: mappedAggregates[objectField[0]], value: objectField[0]}}
                  item={aggregateMasterOverview[objectField[0]]}
                  pdf={true}
                  pdfStyles={styles}
                />
              </View>);
            })}
            </>)}
          </>}

          <Text fixed style={styles.date}>{format(new Date(), 'MM/dd/yyyy')}</Text>
          <Text fixed style={styles.attribution}>Powered by <Link src="https://www.maestrocm.com" style={styles.maestroLink}>Maestro Community Manager</Link></Text>
          <Text fixed style={styles.pageNumber} render={({ pageNumber, totalPages }) => totalPages > 1 ? (`${pageNumber} / ${totalPages}`) : null} />
      </Page>
  </Document>
  )
};

Font.register({
  family: 'Oswald',
  src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

const colors = {
  primary: '#BD2025',
};

const styles = StyleSheet.create({
  body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 45,
      alignItems: 'center', // this is REQUIRED for images to work
      // fontFamily: 'Oswald',
  },

  bodyFix: {
    width: '100%',
  },

  horizontalGrid: {
    width: '100%',
    // padding: 1,
    // display: 'flex',
    // marginHorizontal: -20,
  },
  half: {
    // padding: 1,
    // flexBasis: 1,
    // flex: 1,
    // marginHorizontal: 20,
  },

  title: {
      fontSize: 24,
      textAlign: 'center',
      fontFamily: 'Oswald',
      color: colors.primary,
  },
  author: {
      fontSize: 12,
      textAlign: 'center',
      marginBottom: 12,//40,
      color: 'grey',
  },
  subtitle: {
      fontSize: 18,
      marginTop: 12,
      marginBottom: 0,//-8,
      fontFamily: 'Oswald'
  },
  tableTitle: {
    fontSize: 14,
    marginTop: 12,
    marginBottom: 0,//-8,
    fontFamily: 'Oswald'
},
  text: {
      marginBottom: 12,
      fontSize: 14,
      textAlign: 'justify',
      // fontFamily: 'Times-Roman'
  },
  /*
  imageContainer: {
    // marginVertical: 15,
    // marginHorizontal: 100,
    // width: '100%',//'auto',
    // height: 50,
    alignItems: 'center',
  },
  */
  image: {
      // width: 'auto',
      // height: 'auto',

      // maxHeight: 2000, // this is a stupid workaround to allow really tall logos to still fit the ratio (ratio is only maintained with maxWidth)
      // maxWidth: 200,
      // maxHeight: 50,
      // maxWidth: 200,
      // marginHorizontal: '10%',
      // backgroundColor: 'red',
  },
  header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: 'center', // uncomment when image container is functinoal
      color: 'grey',
  },
  imageContainer: {
    flex: 1,
  },
  maestroImageContainer: {
    flex: 1,
  },

  tableHeader: {
      padding: 5,
      paddingTop: 8,
      fontSize: 12,
    //   fontWeight: 'bold',
  },
  tableCell: {
      padding: 5,
  },
  tableCellHeader: {
    // padding: 5,
    fontWeight: 'bold',
    fontFamily: 'Oswald',
  },
  smallTableHeader: {
    padding: 3,
    paddingTop: 5,
    fontSize: 10,
  },
  smallTableCell: {
    padding: 3,
  },

  date: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 45,//47, // 35 + 12
      right: 0,
      textAlign: 'left',
      color: 'grey',
  },
  attribution: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
  },
  maestroLink: {
      textDecoration: 'none',
      color: colors.primary,
  },
  pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 45,//47, // 35 + 12
      textAlign: 'right',
      color: 'grey',
  },
});

const mockProps = {
    reportInfo: {
        communityName: '',
        name: '',
        author: '',
        description: '',
        statsOnly: false,
    },
    report: {
        //
    },
};

const ShowPdf = (props) => {
    const finalProps = {
        ...mockProps,
        ...props,
    };
  return (
    <PDFViewer style={{width: '100%', height: '100%'}}>
      <MaestroPdf {...finalProps} />
    </PDFViewer>
  );
}

const SavePdf = (props) => {
    const finalProps = {
      ...mockProps,
      ...props,
    };

    const [loading, setLoading] = useState(false);
    // handle errors

    // todo: figure out how to do this deferred after updating report info instead of on click
    return (
      <Button
        color="neutral"
        variant="outlined"
        size="sm"
        disabled={loading}
        loading={loading}
        className={`btn ${loading ? 'disabled' : 'btn-primary'}`}
        onClick={() => {
          setLoading(true);

          const a = document.createElement("a");
          // a.target = "_blank";
          // a.setAttribute('target', '_blank');
          // document.body.appendChild(a);

          pdf(<MaestroPdf {...finalProps} />)
          .toBlob()
          .then(blob => {
            setLoading(false);
            const blobUrl = window.URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');

            /*
            a.href = blobUrl;
            // a.target = "_blank";
            a.setAttribute('target', '_blank');
            a.download = finalProps.reportInfo.name+".pdf";
            a.click();
            setTimeout(() => {
              window.URL.revokeObjectURL(blobUrl);
              document.body.removeChild(a);
            }, 0);
            */
          });
        }}
      >
        Download PDF
        {/* {loading ? 'Generating PDF (will take a sec)' : 'Download PDF'} */}
      </Button>
    );

    /*
    return(
      <BlobProvider document={<MaestroPdf {...finalProps} />} fileName={finalProps.reportInfo.name}>
        {({ url, loading, error }) => error ? 'PDF Error - Contact Support' : (
          <a className={`btn ${loading ? 'disabled' : 'btn-primary'}`} href={url} target="_blank" rel="noopener noreferrer">
            {loading ? 'Generating PDF...' : 'Download PDF'}
          </a>
        )}
      </BlobProvider>
    );

    return (
        <PDFDownloadLink document={<MaestroPdf {...finalProps} />} fileName={finalProps.reportInfo.name} className='btn btn-primary'>
            {({ blob, url, loading, error }) =>
                loading ? 'Generating PDF...' : 'Download PDF'
            }
        </PDFDownloadLink>
    );
    */
}

export {
  MaestroPdf,
  SavePdf,
  ShowPdf,
};
